import styled from '@emotion/styled'

export const StyleCard = styled.div<any>`
  border: 1px solid ${(props: any) => props.theme.colors.white150};
  background: ${(props: any) => props.theme.colors.white};
  padding: 20px;
  border-radius: 12px;
`
export const StyleImageWrapper = styled.div`
  height: 200px;
  border-radius: 12px;
  background: ${(props: any) => props.theme.colors.secondary100};
  position: relative;
  img {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    object-fit: cover;
  }
`

export const StylePriceTag = styled.div`
  background: ${(props: any) => props.theme.colors.secondary200};
  padding: 10px 15px;
  border-radius: 8px;
  position: absolute;
  bottom: 20px;
  right: 20px;
`

export const StyleContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  margin-top: 15px;
`

export const StyleTag = styled.div`
  border: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  padding: 7px 15px;
  display: flex;
  align-items: center;
  column-gap: 5px;
  border-radius: 4px;
`
